import { Component, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { APP_COMMIT, APP_VERSION } from '../../../version';

@Component({
  selector: 'app-sidenav',
  imports: [RouterLink, MatListModule, MatIconModule, RouterLinkActive],
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.scss'
})
export class SidenavComponent {
  public router = inject(Router);
  public version = APP_VERSION;
  public commit = APP_COMMIT;
}
